import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card card-promo" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "card-text" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "expiry"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "promo bg-secondary" }, "PROMO", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.promo.img,
      alt: _ctx.promo.title,
      class: "w-100"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        href: _ctx.promo.url,
        class: "card-title stretched-link"
      }, _toDisplayString(_ctx.promo.title), 9, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.promo.teaser)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              innerHTML: _ctx.promo.teaser
            }, null, 8, _hoisted_6))
          : _createCommentVNode("", true),
        (_ctx.promo.date_expires)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Expires: " + _toDisplayString(_ctx.promo.date_expires), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_8
  ]))
}